import React from 'react'

const JobsSolidIcon = () => {
	return (
		<svg width={35} height={32} viewBox='0 0 35 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M34.038 7.416C34 6.23 33.076 5.313 31.883 5.275h-8.394V2.102c0-.573-.154-1.108-.578-1.529C22.526.191 21.986 0 21.447 0h-8.971a2.017 2.017 0 00-1.964 1.95c-.039 1.108 0 2.216 0 3.325H2.233C1.04 5.199.04 6.192 0 7.339v21.559c.077 1.185 1.04 2.102 2.272 2.14H31.69c1.27.038 2.348-1.07 2.31-2.332.038-.42.038-21.29.038-21.29zM12.36 3.058c0-.65.5-1.147 1.155-1.147h6.931a1.13 1.13 0 011.155 1.147v2.217h-9.24V3.058zm2.195 10.626h.038-.038z'
				fill='currentColor'
			/>
		</svg>
	)
}

export default JobsSolidIcon
